module.exports = __webpack_public_path__ + "img/icon_close@2x.02bca1c7.png";